/*
 * Show tokens: a warning's Show (FixHere), or taking you to a field (a field's focusToken), brings something into view and flashes
 * it, once per press. Each press gets a new token (nextShowToken: unique across the app); once it's been shown it's remembered,
 * so drawing it again (moving to another tab and back) doesn't show it again, and only a new press does.
 */
let lastToken = 0;
const shown = new Set<number>();

/** A token for a new Show press. */
export const nextShowToken = () => ++lastToken;

/** Whether a token has been shown already (drawn again since: nothing to do). */
export const alreadyShown = (token: number) => shown.has(token);

/** A token's been shown: marked once its work is done (StrictMode runs an effect twice, cancelling the first). */
export const markShown = (token: number) => {
    shown.add(token);
};

/** Flash `el` with `className` (an animation in styles.css), restarted each time, even mid-flash: Show pressed again and again. */
export function flash(el: HTMLElement, className: string) {
    el.classList.remove(className);
    // Reading its size makes the browser see it without the class, so adding it again restarts the animation.
    void el.offsetWidth;
    el.classList.add(className);
}
